export const ICON_SIZES = {
    small: "w-4 h-4",
    medium: "w-5 h-5",
    large: "w-6 h-6",
    jumbo: "w-7 h-7",
    huge: "w-8 h-8",
};
